import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, useParams } from 'react-router-dom';
import { collection, getDoc, doc, setDoc, getDocs, writeBatch } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import { saveUserLog } from './LogandUtils'; // 경로에 맞게 수정

import styleClasses from './css/MyPage.module.scss';

function PushAlbum() {
  const [searchParams] = useSearchParams();
  const albumIdsParam = searchParams.get('albumId'); 
  const albumIds = albumIdsParam ? albumIdsParam.split(',') : [];
  const navigate = useNavigate();
  const user = auth.currentUser;
  const { attribute } = useParams();

  const [musicards, setMusicards] = useState([]);
  const [selectedMusicard, setSelectedMusicard] = useState('');
  const [selectedType, setSelectedType] = useState('ownAlbums');

  // 만약 attribute가 unreleased라면 카테고리를 unreleasedAlbums로 고정
  useEffect(() => {
    if (attribute === 'unreleased') {
      setSelectedType('unreleasedAlbums');
    }
  }, [attribute]);

  useEffect(() => {
    if (!user) {
      console.error("사용자가 로그인되어 있지 않습니다.");
      navigate('/login');
      return;
    }

    const fetchMusicards = async () => {
      try {
        const userDoc = await getDoc(doc(db, "users", user.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          const musicardList = Object.entries(userData.musicard || {}).map(([key, value]) => ({
            id: key,
            name: value,
          }));
          setMusicards(musicardList);
        } else {
          console.error("사용자 문서가 존재하지 않습니다.");
        }
      } catch (error) {
        console.error("뮤지카드 가져오기 오류:", error);
      }
    };

    fetchMusicards();
  }, [user, navigate]);

  const handleSubmit = async () => {
    // attribute가 unreleased면 고정된 unreleasedAlbums 사용
    const targetType = attribute === 'unreleased' ? 'unreleasedAlbums' : selectedType;

    if (!selectedMusicard || albumIds.length === 0) {
      alert("뮤지카드와 앨범을 선택해주세요.");
      return;
    }
  
    try {
      // 선택된 각 albumId에 대해 작업 수행
      for (const albumId of albumIds) {
        // 1. users_data에서 전체 앨범 데이터를 가져오기
        const userAlbumRef = doc(db, `users_data/${user.uid}/${attribute}/${albumId}`);
        const albumSnap = await getDoc(userAlbumRef);
        if (!albumSnap.exists()) {
          alert(`복사할 앨범 데이터를 찾을 수 없습니다: ${albumId}`);
          continue;
        }
        const albumData = albumSnap.data();

        // 2. 가져온 앨범 데이터에 albumId와 ownerId를 추가하여 musicians 컬렉션에 저장
        const albumRef = doc(db, `musicians/${selectedMusicard}/${targetType}/${albumId}`);
        await setDoc(albumRef, { 
          ...albumData,
          albumId,
          ownerId: user.uid,
        }, { merge: true });

        // 3. users_data의 해당 앨범의 트랙 정보를 musicians의 앨범 하위 컬렉션으로 복사
        const sourceTracksRef = collection(db, `users_data/${user.uid}/${attribute}/${albumId}/tracks`);
        const tracksSnapshot = await getDocs(sourceTracksRef);
        const batch = writeBatch(db);
        tracksSnapshot.forEach((trackDoc) => {
          const trackData = trackDoc.data();
          const destTrackRef = doc(db, `musicians/${selectedMusicard}/${targetType}/${albumId}/tracks`, trackDoc.id);
          batch.set(destTrackRef, trackData);
        });
        await batch.commit();

        const changedPaths = [albumRef.path, sourceTracksRef.path];
        await saveUserLog('musicard_logs', selectedMusicard, 'create', changedPaths, 'PushAlbum');

        // 4. users_data의 해당 앨범 문서에서 act 필드 업데이트 (기존 act와 병합)
        await setDoc(userAlbumRef, {
          act: {
            [selectedMusicard]: targetType
          }
        }, { merge: true });
      }
  
      alert("뮤지카드에 선택한 앨범들이 추가되었습니다!");
      navigate(`/my-page/archive/${attribute}`);
    } catch (error) {
      console.error("앨범 추가 오류:", error);
    }
  };  

  return (
    <div className={styleClasses.pushPage}>
      <h1>뮤지카드로 앨범 내보내기</h1>

      <div className={styleClasses.form}>
        <label>내 뮤지카드 선택</label>
        <select value={selectedMusicard} onChange={(e) => setSelectedMusicard(e.target.value)}>
          <option value="">뮤지카드를 선택하세요</option>
          {musicards.map((card) => (
            <option key={card.id} value={card.name}>
              {card.name}
            </option>
          ))}
        </select>

        {attribute === 'unreleased' ? (
          <div>
            <label>카테고리</label>
            <p>미공개 음반 및 음원 (Unreleased)</p>
          </div>
        ) : (
          <div>
            <label>어느 카테고리로 보낼까요?</label>
            <select value={selectedType} onChange={(e) => setSelectedType(e.target.value)}>
              <option value="ownAlbums">내 소유 앨범 (Musician Albums)</option>
              <option value="collaboAlbums">협업 앨범 (Collaboration Albums)</option>
            </select>
          </div>
        )}

        <button onClick={handleSubmit} className="primaryButton">
          앨범 내보내기
        </button>
      </div>
    </div>
  );
}

export default PushAlbum;